import { SET_SELECTED_DOCUMENT } from '../actionTypes';
import { multiTemplateReviewActions } from '../reducer';

export default (values) =>
    multiTemplateReviewActions[SET_SELECTED_DOCUMENT](values);
